export const stripHtml = (html: string | undefined): string => {
    if (!html) return '';
    return html
        .replace(/<\/(p|li|h[1-6])>/gi, ' ')
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};
